export default __webpack_public_path__ + "static/fixedMenuMessangerIcon-ed4d208952be4e13a526944d97988791.svg";